import React, { useState } from 'react';
import { NumberBox } from '../NumberBox/NumberBox';
import { MoneyBox } from '../NumberBox/MoneyBox';
import { Panel, PanelTheme } from '@apply/components';

export const NumberBoxDemo: React.FC = () => {
    // State for each example
    const [basicValue, set_basicValue] = useState(0);
    const [readOnlyValue, set_readOnlyValue] = useState(0);
    const [moneyValue, set_moneyValue] = useState(0);
    const [readOnlyMoneyValue, set_readOnlyMoneyValue] = useState(0);
    const [moneyValueDisplayChange, set_moneyValueDisplayChange] = useState(0);

    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>NumberBox</li>
            <br />
            <Panel theme={PanelTheme.White}>
                <div style={{ padding: '1rem' }}>
                    {/* Example 1: NumberBox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <NumberBox
                            value={basicValue}
                            onChange={set_basicValue}
                            label='Basic NumberBox'
                        />
                    </div>

                    {/* Example 2: Read-Only NumberBox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <NumberBox
                            value={readOnlyValue}
                            onChange={set_readOnlyValue}
                            label='Read-Only NumberBox'
                            readOnly={true}
                        />
                    </div>

                    {/* Example 3: MoneyBox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MoneyBox
                            value={moneyValue}
                            onChange={set_moneyValue}
                            label='MoneyBox'
                        />
                    </div>

                    {/* Example 4: Read Only Moneybox*/}
                    <div style={{ marginBottom: '1rem' }}>
                        <MoneyBox
                            value={readOnlyMoneyValue}
                            onChange={set_readOnlyMoneyValue}
                            label='Read-Only MoneyBox'
                            readOnly={true}
                        />
                    </div>
                    {/* Example 5: MoneyBox - Change Display Required */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MoneyBox
                            value={moneyValueDisplayChange}
                            displayChange={true}
                            onChange={set_moneyValueDisplayChange}
                            label='MoneyBox (Display Decimals)'
                        />
                    </div>
                </div>
            </Panel>
        </div>
    );
};
